import { InjectRepository } from "@nestjs/typeorm";
import { RmBudgetEntity } from "./rm-budget.entity";
import { Like, Repository, getManager } from "typeorm";
import { Injectable } from "@nestjs/common";
import { CommonResponse, PlantIdRequest, RmBudgetColumns, RmBudgetResponseModel } from "@gtpl/shared-models/masters";
import { GenericTransactionManager } from "apps/services/backend/typeorm-transactions/generic-transaction-manager";
import appSettings from "apps/services/config";
import {EmployeeDetails} from 'apps/services/masters/src/app/employee-details/employee-details.entity'
import { RmBudgetInfoReq } from "@gtpl/shared-models/raw-material-procurement";
import moment, { months } from "moment";
@Injectable()
export class RmBudgetService {
    constructor(
    @InjectRepository(RmBudgetEntity)
    private repo : Repository<RmBudgetEntity>)
    {}
    async createRmBudget(req : any): Promise<RmBudgetResponseModel> {
        // console.log(req,"ooppp")
        const transactionManager = new GenericTransactionManager();
        try {
            await transactionManager.startTransaction()
            const flag = new Set<boolean>()
            const columnArray = []
            const updatedArray = req.map((obj) => {
                const updatedObj = {}
                for (const key in obj) {
                    const newKey = key.replace(/\s/g, '').replace(/[\(\)\.]/g, '').replace(/-/g, '');
                    if (newKey != '') {
                        columnArray.push(newKey);
                        updatedObj[newKey] = obj[key];
                    }
                }
                return updatedObj;
            })
            const difference = columnArray.filter((element) => !RmBudgetColumns.includes(element));
            console.log(difference,"difference")
            if (difference.length > 0) {
                await transactionManager.releaseTransaction();
                return new RmBudgetResponseModel(false, 1110, "Excel columns doesn't match. Please attach the correct file.");
            }

            const convertedData = updatedArray.map((obj) => {
                const updatedObj = {};
                for (const key in obj) {
                    const value = obj[key];
                    if (value === "") {
                        updatedObj[key] = null;
                    } else {
                        updatedObj[key] = value;
                    }
                }
                return updatedObj;
            });
            // const deleteData = await transactionManager.getRepository(RmBudgetEntity).delete({})
            // if (deleteData) {
            //     flag.add(true)
            // } else {
            //     flag.add(false)
            //     return new RmBudgetResponseModel(false, 0, 'Something went wrong in data deletion')
            // }
            for (const data of convertedData) {
                // console.log(data);
                const procurementManager =await transactionManager.getRepository(EmployeeDetails).findOne({employeeName: data.ProcurementManager})
                if(procurementManager){
                    flag.add(true)
                    } else {
                        flag.add(false)
                        await transactionManager.releaseTransaction();
                        return new RmBudgetResponseModel(false, 0, `${data.ProcurementManager} was not a 
                        Procurement Manager`);
                    }
                    const exist = await transactionManager.getRepository(RmBudgetEntity).find({where:{count:data.Count,procurementManagerId : procurementManager.employeeId,year : data.Year,month : data.Month}})
                    if(exist.length>0){
                        const update = await transactionManager.getRepository(RmBudgetEntity).update({id:exist[0].id},{quantity:data.Quantity})
                        if(update.affected){
                            flag.add(true)
                        }else{
                        flag.add(false)
                        await transactionManager.releaseTransaction();
                        return new RmBudgetResponseModel(false, 0,`something went wrong for ${data.Count} count against ${data.ProcurementManager} with same ${data.Year} year and ${data.Month} month`);

                        // return new RmBudgetResponseModel(false, 0,`${data.Count} already exists against ${data.ProcurementManager} with same ${data.Year} year and ${data.Month} month`);
                        }
                    }else{
                if (data.Count != null) {
                    const entity = new RmBudgetEntity()
         entity.createdUser = req.createdUser
         entity.updatedUser = req.updatedUser
         entity.count = data.Count
        entity.month = data.Month
        entity.year = data.Year
        entity.quantity = data.Quantity
        entity.procurementManagerId = procurementManager.employeeId
        // console.log(entity);
                    const addSave = await transactionManager.getRepository(RmBudgetEntity).save(entity)
                    
                    if (addSave) {
                        flag.add(true)
                    } else {
                        flag.add(false)
                        await transactionManager.releaseTransaction();
                        break;
                    }
                } 

            }
        }
            if (!flag.has(false)) {
                await transactionManager.completeTransaction();
                return new RmBudgetResponseModel(true, 1, 'Data saved successfully');
            } else {
                await transactionManager.releaseTransaction();
                return new RmBudgetResponseModel(false, 0, 'Something went wrong');
            }
        } catch (err) {
            await transactionManager.releaseTransaction();
            return new RmBudgetResponseModel(false, 0, 'Something went wrong');
        }
    }

    async getAllRmBudget():Promise<CommonResponse>{  
        try{
        const manager = getManager();
        let query =`SELECT r.count, r.quantity, r.year, r.month, e.employee_name as procurementManager FROM rm_budget r 
        LEFT JOIN `+ appSettings.masters_db +`.employee_details e ON e.employee_id = r.procurement_manager_id`
        const details =await manager.query(query);
      return new CommonResponse(true, 1, 'No data found',details)
      
      } catch (err) {
      
        throw err
      }
      
      }
      async getBudgetRangeAgainstCount(req:RmBudgetInfoReq):Promise<CommonResponse>{
        const manager = getManager()
        try{
const getMonthName =['January','February','March','April','May','June','July','August','September','October','November','December']
            const year = moment(req.reweighmentDate).get("year")
            const month =getMonthName[Number(moment(req.reweighmentDate).format('MM')) - 1]
            // console.log(moment(req.reweighmentDate).format('MM'),'getMonthhhhhhhhhhhhh');
            // console.log(getMonthName[Number(3) - 1]);
            
            let querry = `SELECT r.count FROM ${appSettings.masters_db}.rm_budget r WHERE r.year='${year}' AND r.count NOT REGEXP '[A-Za-z]' AND r.month ='${month}'`
            const data = await manager.query(querry)
            let range
            if(data.length>0){
            for (const value of data) {
                // console.log(value,'pppppppp');
                
                        const [min, max] = value.count.split('-').map(Number);
                        if (req.count >= min && req.count <= max) {
                          range = value.count
                        }
            }
                    if(range == undefined || range == null){
                        for (const value of data) {
                            // console.log(Number(req.count)+1,Number(req.count)+1,'pppppppp');
                            
                                    const [min, max] = value.count.split('-').map(Number);
                                    // console.log(min,max,'min and max');
                                    
                                    if (Number(req.count) >= Number(min-1) && Number(req.count) <= Number(max+1)) {
                                      range = value.count
                                    }
                                    if(range!= undefined){
                                        break;
                                    }
                        }
                        if(range == undefined || range == null){
                        range = 'OTHERS'
                        }
                    }
                    console.log(range,'rangeeeeeeeeeee');
                    
                    
                    
            return new CommonResponse(true,1,'Data retrieved',range)
                }
                else{
                    return new CommonResponse(false,0,'RM Budget Not found for this month')

                }
    }catch(err){
        throw err
    }
}
}